module.exports = __webpack_public_path__ + "static/media/autumn-leaves-beautiful-color-206648.fbbb7256.jpg";